
import { create } from "zustand";
import axios from "axios";
import { API_BASE_URL1 } from "../../../../../Services/baseApiUrl";
import { apiCall } from "../../../../../../utils/apiCall";
import { toast } from "react-toastify";

const TippingFeeCalculationStore = create((set, get) => ({
    tippingFeeReportData: [],
    tippingFeeInnerZoneReportData: [],
    ieNameList: [],
    loading: false,
    error: false,

    fetchTippingFeeCalculationReport: async (queryParams) => {
        set({ loading: true, error: null });
        const queryString = new URLSearchParams(queryParams).toString();
        try {
            const tippingDataReport = await apiCall({
                url: `${API_BASE_URL1}KpiReport/TippingFeeCalculationReport?${queryString}`,
                method: "get",
                token: localStorage.getItem("token"),
            });
    
            set({ 
                tippingFeeReportData: Array.isArray(tippingDataReport) ? tippingDataReport : [], 
                loading: false 
            });
           
    
        } catch (error) {
            console.log(error.response?.data?.message || "Error fetching data");

            if (error.response && error.response.status === 404) {
                set({ 
                    tippingFeeReportData: [], 
                    filteredObservations: [], 
                    error: "No hygiene observations found.", 
                    loading: false 
                });
            } else {
                set({ error: error.response?.data?.message || "Something went wrong", loading: false });
            }
        } finally {
            set({ loading: false });
        }
    },

    fetchTippingFeeCalculationInnerZoneReport: async (queryParams) => {
        set({ loading: true, error: null });
        const queryString = new URLSearchParams(queryParams).toString();
        try {
            const tippingDataInnerReport = await apiCall({
                url: `${API_BASE_URL1}KpiReport/TippingFeeCalculationSummary?${queryString}`,
                method: "get",
                token: localStorage.getItem("token"),
            });
    
            set({ 
                tippingFeeInnerZoneReportData: Array.isArray(tippingDataInnerReport) ? tippingDataInnerReport : [], 
                loading: false 
            });
           
    
        } catch (error) {
            console.log(error.response?.data?.message || "Error fetching data");

            if (error.response && error.response.status === 404) {
                set({ 
                    tippingFeeInnerZoneReportData: [], 
                    error: "No Data found.", 
                    loading: false 
                });
            } else {
                set({ error: error.response?.data?.message || "Something went wrong", loading: false });
            }
        } finally {
            set({ loading: false });
        }
    },

}));

export default TippingFeeCalculationStore;
